/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Card} from "@canopy-iiif/app/ui";
function _createMdxContent(props) {
  return <Card href={props.record?.href} title={props.record?.title || props.record?.href || "Untitled"} src={props.record?.type === "work" ? props.record?.thumbnail : undefined} imgWidth={props.record?.thumbnailWidth} imgHeight={props.record?.thumbnailHeight} aspectRatio={props.thumbnailAspectRatio} />;
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}
